// Other names people search a country by (Ben, 2026-10-18: "Holland" should find the Netherlands).
// Used by the in-page searches that list countries: the League chip and the league dropdowns (a
// league's country heading) and the Nationality chip. Anyone can add a line: `names` = how the
// data may spell the country, `aliases` = what a person might type instead. Matching ignores case
// and accents.

export const COUNTRY_ALIASES: readonly { names: readonly string[]; aliases: readonly string[] }[] = [
  { names: ["Netherlands", "The Netherlands"], aliases: ["Holland", "Dutch", "Nederland"] },
  { names: ["United States of America", "United States", "USA"], aliases: ["USA", "US", "America", "American", "United States"] },
  { names: ["England"], aliases: ["English"] },
  { names: ["Scotland"], aliases: ["Scottish"] },
  { names: ["Wales"], aliases: ["Welsh", "Cymru"] },
  { names: ["Northern Ireland"], aliases: ["NI", "Ulster"] },
  { names: ["Republic of Ireland", "Ireland"], aliases: ["Ireland", "Irish", "Eire", "ROI"] },
  { names: ["United Kingdom"], aliases: ["UK", "Britain", "Great Britain", "GB", "British"] },
  { names: ["Spain"], aliases: ["Spanish", "España", "Espana"] },
  { names: ["Germany"], aliases: ["German", "Deutschland"] },
  { names: ["France"], aliases: ["French"] },
  { names: ["Italy"], aliases: ["Italian", "Italia"] },
  { names: ["Portugal"], aliases: ["Portuguese"] },
  { names: ["Brazil"], aliases: ["Brazilian", "Brasil"] },
  { names: ["Argentina"], aliases: ["Argentine", "Argentinian"] },
  { names: ["Belgium"], aliases: ["Belgian"] },
  { names: ["Switzerland"], aliases: ["Swiss", "Schweiz", "Suisse"] },
  { names: ["Austria"], aliases: ["Austrian", "Österreich"] },
  { names: ["Denmark"], aliases: ["Danish", "Danmark"] },
  { names: ["Sweden"], aliases: ["Swedish", "Sverige"] },
  { names: ["Norway"], aliases: ["Norwegian", "Norge"] },
  { names: ["Finland"], aliases: ["Finnish", "Suomi"] },
  { names: ["Japan"], aliases: ["Japanese", "Nippon"] },
  { names: ["Mexico"], aliases: ["Mexican"] },
  { names: ["Czech Republic", "Czechia"], aliases: ["Czechia", "Czech Republic", "Czech"] },
  { names: ["Türkiye", "Turkey"], aliases: ["Turkey", "Turkiye", "Turkish"] },
  { names: ["Korea Republic", "South Korea", "Republic of Korea"], aliases: ["South Korea", "Korea", "Korean"] },
  { names: ["Korea DPR", "North Korea"], aliases: ["North Korea"] },
  { names: ["China PR", "China"], aliases: ["China", "Chinese"] },
  { names: ["Côte d'Ivoire", "Ivory Coast"], aliases: ["Ivory Coast", "Cote d'Ivoire"] },
  { names: ["Congo DR", "DR Congo", "Democratic Republic of the Congo"], aliases: ["DR Congo", "DRC", "Congo"] },
  { names: ["Bosnia and Herzegovina", "Bosnia-Herzegovina"], aliases: ["Bosnia"] },
  { names: ["North Macedonia"], aliases: ["Macedonia"] },
  { names: ["Russia", "Russian Federation"], aliases: ["Russia", "Russian"] },
  { names: ["Iran", "IR Iran"], aliases: ["Iran", "Persia"] },
  { names: ["Cape Verde", "Cabo Verde"], aliases: ["Cape Verde", "Cabo Verde"] },
  { names: ["Eswatini"], aliases: ["Swaziland"] },
  { names: ["Myanmar"], aliases: ["Burma"] },
  { names: ["Saudi Arabia"], aliases: ["Saudi", "KSA"] },
  { names: ["United Arab Emirates"], aliases: ["UAE", "Emirates"] },
  { names: ["New Zealand"], aliases: ["NZ", "Kiwi"] },
  { names: ["Australia"], aliases: ["Australian", "Aussie"] },
];
